export default __webpack_public_path__ + "static/media/arrow-drop.74221e9e.svg";